import { z } from 'zod';
/**
 * Declares one UI usage event: its literal name and its closed payload. A function rather
 * than an object literal so the tuple of declarations keeps each name as a literal type,
 * which is what lets `z.discriminatedUnion('name', ...)` and the types derived from it
 * type-check without a cast.
 *
 * Lives apart from `ui-usage.events.ts` because it writes the `name` key, which the
 * `no-pii-in-events` lint refuses in an events file.
 */
export function defineUiEvent(name, payload) {
    return z.strictObject({ name: z.literal(name), payload });
}
